<app-loader *ngIf="isDisabled || isGDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col">
                Attendance
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-sm btn-outline-primary ms-1" [disabled]="isDisabled || isGDisabled"
                    (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                    aria-controls="collapseFilter">
                    <i class="bi bi-caret-down-fill" *ngIf="!isDisabled &&  !isGDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled || isGDisabled"></span>
                    {{!isDisabled?'Search':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" class="mt-1">
            <form>
                <div class="row">

                    <div class="col-md-6">
                        <label class="Label" for="Branch">Branch<span class="text-danger">*</span></label>
                        <ng-select [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                            placeholder="Select Branch" [(ngModel)]="Filter.BranchId" name="Branch"
                            (change)="ComboLoad('Client');clear()" (clear)="clearField('Branch')">
                        </ng-select>
                    </div>

                    <div class="col-md-6">
                        <label class="Label" for="Client">Client<span class="text-danger">*</span></label>
                        <ng-select [items]="Clients" bindLabel="ClientGroupName" bindValue="ClientGroupMasterID"
                            placeholder="Select Client" [(ngModel)]="Filter.ClientID" name="Client"
                            (change)="ComboLoad('Site');clear();" (click)="selectLocation('Client')"
                            (clear)="clearField('Client')">
                        </ng-select>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col-md-6">
                        <label class="Label" for="Site">Site<span class="text-danger">*</span></label>
                        <ng-select [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID"
                            placeholder="Select Site" [(ngModel)]="Filter.SiteID" name="Site"
                            (change)="clear();ESS_GetCompanyParameterOAS()" (click)="selectLocation('Site')">
                        </ng-select>
                    </div>

                    <div class="col-md-3">
                        <label class="Label">Date<span class="text-danger">*</span></label>
                        <div class="input-group">
                            <input class="form-control" placeholder="dd-mm-yyyy" name="Date" [(ngModel)]="Filter.Date"
                                ngbDatepicker #Date="ngbDatepicker" (ngModelChange)="datechange();clear()"
                                [maxDate]="maxDate" [disabled]="Filter.SiteID == null" required />
                            <button class="btn btn-outline-secondary bi bi-calendar3" type="button"
                                (click)="Date.toggle()"></button>
                        </div>
                    </div>


                    <div class="col-auto">
                        <button type="submit" class="btn btn-primary btn-sm mt-4" (click)="LoadAttendance();">
                            <!-- <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span> -->
                            {{!isDisabled?'Search':'Loading...'}}
                        </button>
                    </div>
                    <div class="col-auto">
                        <button type="submit" class="btn btn-primary btn-sm mt-4" (click)="AddReliever()">
                            <!-- <i class="bi bi-plus" *ngIf="!isDisabled"></i> -->
                            <!-- <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span> -->
                            {{!isDisabled?'Reliever':'Loading...'}}
                        </button>
                    </div>
                </div>
            </form>
            <!-- <br> -->
            <hr>
            <div class="row m-1">
                <div class="col-md-1 px-1">
                    <label class="Label" for="SelectAttendanceType">Check </label>
                    <!-- <input type="checkbox" (click)="selectAttendanceType($event, Filter.SelectAttendanceType)"> -->
                </div>
                <div class="col-md-3 px-1">
                    <ng-select [items]="AttendanceTypes" bindLabel="AttendanceType" bindValue="AttendanceTypeCode"
                        placeholder="Select Attendance" [(ngModel)]="Filter.SelectAttendanceType"
                        name="SelectAttendanceType" (clear)="clearAttendanceMark()">
                    </ng-select>
                </div>
                <div class="col-md-1">
                    <button class="btn btn-primary btn-sm" (click)="selectAttendanceType(Filter.SelectAttendanceType)">
                        Apply
                    </button>
                </div>
                <div class="col-md-1"></div>

                <div class="col-md-1 px-1">
                    <label class="Label" for="MarkAttendanceType">Mark All</label>
                </div>
                <div class="col-md-3 px-1">
                    <ng-select [items]="AttendanceTypes" bindLabel="AttendanceType" bindValue="AttendanceTypeCode"
                        placeholder="Mark Attendance" [(ngModel)]="Filter.MarkAttendanceType" name="MarkAttendanceType">
                    </ng-select>
                </div>
                <div class="col-md-1">
                    <button (click)="markAttendanceType(Filter.MarkAttendanceType)" class="btn btn-primary btn-sm">
                        Apply
                    </button>
                </div>
                <!-- <div class="col-md-1">
                    <button class="btn btn-primary btn-sm">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Apply ':'Loading...'}}
                    </button>
                </div> -->
            </div>
            <div class="row mt-2 m-1">
                <div class="col-md-1 px-1">
                    <label class="Label" for="MarkShift">Shift for All</label>
                </div>
                <div class="col-md-3 px-1">
                    <ng-select [items]="Shifts" bindLabel="ShiftTitle" bindValue="ShiftMasterID"
                        placeholder="Select Shift for all" [(ngModel)]="Filter.MarkShift" name="MarkShift">
                    </ng-select>
                </div>

                <div class="col-md-1">
                    <button (click)="markShift(Filter.MarkShift)" class="btn btn-primary btn-sm">Apply</button>
                </div>

                <div class="col-md-1"></div>

                <div class="col-md-1 px-1">
                    <label class="Label" for="MarkDuty">Duty for All</label>
                </div>
                <div class="col-md-3 px-1">
                    <ng-select [items]="DutyForEmployee" bindLabel="DutyName" bindValue="DutyMasterID"
                        placeholder="Select Duty for all" [(ngModel)]="Filter.MarkDuty" name="MarkDuty">
                    </ng-select>
                </div>
                <div class="col-md-1">
                    <button (click)="markDuty(Filter.MarkDuty)" class="btn btn-primary btn-sm">Apply</button>
                </div>
            </div>
            <!-- <hr *ngIf="showCombinations">
            <div *ngIf="showCombinations" class="container">
                <h6>Possible Designation and Duty combinations for {{Filter.SiteName}}</h6>

                <ul class="combo-list">
                    <li *ngFor="let item of DesignationDutyCombination" class="combo-item">
                        <span class="designation">{{ item.DesignationName }}</span>
                        <span class="separator"> - </span>
                        <span class="duty">{{ item.DutyName }}</span>
                    </li>
                </ul>
            </div> -->
            <hr>
        </div>
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th style="width: 5px;">#</th>
                    <th scope="col" style="width: 5px;">
                        <input type="checkbox" name="all" (change)="selectAll($event)" [(ngModel)]="allSelect">
                    </th>
                    <th>Employee</th>
                    <th>Designation/Duty Name</th>
                    <th>Shift Title</th>
                    <th>Attendance</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let TableData of TablesDatas; let i = index">
                    <th scope="row" style="width: 5px;">{{i+1}}</th>
                    <td>
                        <input type="checkbox" [(ngModel)]="TableData.selected" name="row{{i}}"
                            (change)="selectRow($event, TableData); resetSelection()" (click)="resetSelection()">
                    </td>
                    <td>
                        <div class="row" style="align-items: start; width: 350px;">
                            <div class="col-2">
                                <img *ngIf="TableData['EmployeeImage'] != null && TableData['EmployeeImage'] != ''"
                                    mat-card-image class="userImage" (click)="common.FullImage('',{ProfileImage:TableData['EmployeeImage'],
                                    Name: TableData['FullName'],
                                    Code: TableData['EmpCode']})" [src]="TableData['EmployeeImage']" />

                                <div *ngIf="TableData['EmployeeImage'] == null || TableData['EmployeeImage'] == ''"
                                    (click)="common.FullImage('',{ProfileImage:common.PhotoLink(TableData['EmployeeImage'])} )"
                                    class="initial-image">
                                    <div class="image">
                                        {{common.getInitial(TableData['FullName'])}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-10">
                                <div class="d-flex justify-content-between">
                                    <span class="text-label">{{TableData['FullName']}}</span>
                                    <span class="text-label">{{TableData['DailyAttendanceInOutID']}}</span>
                                </div>
                                <span class="text-label-light">#{{TableData['EmpCode']}}</span>
                                <br />
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <label class="text-label" for="InTime">InTime : </label>
                                        <span name="InTime" class="text-label-light">
                                            {{Filter.DateObj}}, {{TableData['InTime']}}
                                        </span>
                                    </div>
                                    <div>
                                        <img *ngIf="TableData['DailyAttendancePhoto'] != null && TableData['DailyAttendancePhoto'] != ''"
                                            mat-card-image class="userImage"
                                            [src]="(TableData['DailyAttendancePhoto'])" />
                                    </div>
                                </div>

                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <label class="text-label" for="OutTime">OutTime : </label>
                                        <span name="OutTime" class="text-label-light">
                                            {{TableData['OutDate']}}, {{TableData['OutTime']}}</span>
                                    </div>
                                    <div>
                                        <img *ngIf="TableData['DailyAttendancePhotoOut'] != null && TableData['DailyAttendancePhotoOut'] != ''"
                                            mat-card-image class="userImage"
                                            [src]="(TableData['DailyAttendancePhotoOut'])" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <ng-select [appendTo]="'body'" style="margin-bottom: 7px;" [items]="Designations"
                            bindLabel="DesignationName" bindValue="DesignationMasterID" placeholder="Designation"
                            [(ngModel)]="TableData['DesignationMasterID']" [disabled]="!TableData.selected">
                        </ng-select>

                        <ng-select [appendTo]="'body'" [items]="Duties" bindLabel="DutyName" bindValue="DutyMasterID"
                            placeholder="Duty Type" [(ngModel)]="TableData['DutyMasterID']"
                            [disabled]="!TableData.selected">
                        </ng-select>
                    </td>
                    <td>
                        <ng-select [appendTo]="'body'" [items]="Shifts" bindLabel="ShiftTitle" bindValue="ShiftMasterID"
                            placeholder="Shift" [(ngModel)]="TableData['ShiftMasterID']"
                            [disabled]="!TableData.selected" (change)="shiftChange(i, TableData['ShiftMasterID'])">
                        </ng-select>

                        <div class="d-flex mt-2">
                            <span style="font-weight: bold; margin-right: 5px;">Client OT</span>
                            <input class="form-control" [(ngModel)]="TableData['BillableOT']" type="text"
                                placeholder="OT" (input)="validateInput($event)">
                        </div>
                    </td>

                    <td>
                        <ng-select [appendTo]="'body'" [items]="AttendanceTypes" bindLabel="AttendanceType"
                            bindValue="AttendanceTypeCode" placeholder="Attendance Type"
                            [(ngModel)]="TableData['AttendanceRemark']" [disabled]="!TableData.selected">
                        </ng-select>

                        <div class="d-flex mt-2">
                            <span style="font-weight: bold; margin-right: 5px;">Internal OT</span>
                            <input class="form-control" [(ngModel)]="TableData['NonBillableOT']" type="text"
                                placeholder="OT" (input)="validateInput($event)">
                        </div>
                    </td>

                </tr>
            </tbody>
        </table>
        <hr *ngIf="showCombinations">
        <div *ngIf="showCombinations">
            <h6>Possible Designation and Duty combinations for {{Filter.SiteName}}</h6>
            <table id="comboTable" class="customeDatatable table table-bordered" style="width:100%"></table>
        </div>
    </div>
    <!-- <div class="card border-radius-0 m-2">
        <div class="card-header">
            Data
        </div>
        <div class="card-body p-1" style="overflow: auto">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th scope="col" style="width: 5px;">
                            <input type="checkbox" name="all" (change)="selectAll($event)" [(ngModel)]="allSelect">
                        </th>
                        <th>Employee</th>
                        <th>Designation/Duty Name</th>
                        <th>Shift Title</th>
                        <th>Attendance</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TablesDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td>
                            <input type="checkbox" [(ngModel)]="TableData.selected" name="row{{i}}"
                            (change)="selectRow($event, TableData); resetSelection()" (click)="resetSelection()">
                        </td>
                        <td>
                            <div class="row" style="align-items: start; width: 350px;">
                                <div class="col-2">
                                    <img *ngIf="TableData['EmployeeImage'] != null && TableData['EmployeeImage'] != ''"
                                        mat-card-image class="userImage" (click)="common.FullImage('',{ProfileImage:TableData['EmployeeImage'],
                                        Name: TableData['FullName'],
                                        Code: TableData['EmpCode']})" [src]="TableData['EmployeeImage']" />
 
                                    <div *ngIf="TableData['EmployeeImage'] == null || TableData['EmployeeImage'] == ''"
                                        (click)="common.FullImage('',{ProfileImage:common.PhotoLink(TableData['EmployeeImage'])} )"
                                        class="initial-image">
                                        <div class="image">
                                            {{common.getInitial(TableData['FullName'])}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-10">
                                    <div class="d-flex justify-content-between">
                                        <span class="text-label">{{TableData['FullName']}}</span>
                                        <span class="text-label">{{TableData['DailyAttendanceInOutID']}}</span>
                                    </div>
                                    <span class="text-label-light">#{{TableData['EmpCode']}}</span>
                                    <br />
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <label class="text-label" for="InTime">InTime : </label>
                                            <span name="InTime" class="text-label-light">
                                                {{Filter.DateObj}}, {{TableData['InTime']}}
                                            </span>
                                        </div>
                                        <div>
                                            <img *ngIf="TableData['DailyAttendancePhoto'] != null && TableData['DailyAttendancePhoto'] != ''"
                                            mat-card-image class="userImage"
                                            [src]="(TableData['DailyAttendancePhoto'])" />
                                        </div>
                                    </div>
 
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <label class="text-label" for="OutTime">OutTime : </label>
                                            <span name="OutTime" class="text-label-light">
                                                {{TableData['OutDate']}}, {{TableData['OutTime']}}</span>
                                        </div>
                                        <div>
                                            <img *ngIf="TableData['DailyAttendancePhotoOut'] != null && TableData['DailyAttendancePhotoOut'] != ''"
                                            mat-card-image class="userImage"
                                            [src]="(TableData['DailyAttendancePhotoOut'])" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <ng-select style="margin-bottom: 7px;" [items]="Designations" bindLabel="DesignationName"
                                bindValue="DesignationMasterID" placeholder="Designation"
                                [(ngModel)]="TableData['DesignationMasterID']"
                                (change)="loadDuty(TableData['DesignationMasterID'], i)" [disabled]="!TableData.selected">
                            </ng-select>
 
                            <ng-select [items]="Duties" bindLabel="DutyName" bindValue="DutyMasterID"
                                placeholder="Duty Type" [(ngModel)]="TableData['DutyMasterID']" [disabled]="!TableData.selected">
                            </ng-select>
                        </td>
                        <td>
                            <ng-select [items]="Shifts" bindLabel="ShiftTitle" bindValue="ShiftMasterID"
                                placeholder="Shift" [(ngModel)]="TableData['ShiftMasterID']" [disabled]="!TableData.selected"
                                (change)="shiftChange(i, TableData['ShiftMasterID'])">
                            </ng-select>
                        </td>
                       
                        <td>
                            <ng-select [items]="AttendanceTypes" bindLabel="AttendanceType"
                                bindValue="AttendanceTypeCode" placeholder="Attendance Type"
                                [(ngModel)]="TableData['AttendanceRemark']" [disabled]="!TableData.selected">
                            </ng-select>
                        </td>
                       
                    </tr>
                </tbody>
            </table>
        </div>
        
    </div> -->
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <!-- <div class="col-auto">
                <button type="submit" class="btn btn-primary btn-sm" (click)="AddReliever()">
                    <i class="bi bi-plus" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
                    {{!isDisabled?'Reliever':'Loading...'}}
                </button>
            </div> -->
            <div class="col-auto">
                <button type="button" class="btn btn-primary btn-sm" (click)="Save(); resetSelection();">
                    <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>